import React, { PropTypes as T } from 'react';
import ResultCategory from './resultCategory';
import translate from '../../../utils/translate';
import withDevice from '../../common/withDeviceHOC';

export class HeaderSearchResults extends React.Component {
  static propTypes = {
    search:        T.object,
    searchResults: T.array,
    searchTerm:    T.string,
    isMobile:      T.bool
  };

  getCategoriesForMobile = () => {
    let cats = [];
    let overflow = 12;
    if (this.props.searchResults) {
      for (let i = 0; i < this.props.searchResults.length; i++) {
        if (overflow > 0 && this.props.searchResults[i].results) {
          let category = this.props.searchResults[i];
          category.results = (category.results.length > overflow)
            ? category.results.slice(0, overflow)
            : category.results;
          overflow = overflow - category.results.length;
          cats.push(category);
        }
      }
    }
    return cats;
  };

  renderCategories = () => {
    let cats = this.props.isMobile ? this.getCategoriesForMobile() : this.props.searchResults;
    return cats.map((result, index) => {
      return <ResultCategory key={index} {...result} searchTerm={this.props.searchTerm} />;
    }, this);
  };

  renderAllResultsLink = () => {
    if (this.props.searchResults.length) {
      let url = this.props.search.searchUrl + this.props.searchTerm;

      // As cannot guarantee keyword is always being sent as a parameter check if a ? already exists in url.
      if (url.search(/\?/) !== -1) {
        url += '&tm_link=tm_search_suggest_seeall';
      }
      else {
        url += '?tm_link=tm_search_suggest_seeall';
      }

      return (
        <div className="header__panel__showall" data-component="header-searchresults-showall">
          <a
            href={url}
            className="header__panel__showall__link">
            {translate('searchSuggestModule', 'SEE_ALL_RESULTS_FOR')}
            {' '}<em>{this.props.searchTerm}</em>
          </a>
        </div>
      );
    }
  };

  renderHeader = () => {
    if (!this.props.isMobile) {
      return <h3 className="header__panel__title">{translate('searchModule', 'SEARCH')}</h3>;
    }
  };

  render () {
    if (this.props.searchResults.length === 0) {
      return false;
    }

    return (
      <div>
        {this.renderHeader()}
        <div className="header__searchresults" data-component="header-searchresults">
          <div className="header__searchresults__results">
            {this.renderCategories()}
          </div>
          {this.renderAllResultsLink()}
        </div>
      </div>
    );
  }
}

export default withDevice(HeaderSearchResults);



// WEBPACK FOOTER //
// ./frontend/react/components/header/searchresults/index.js